import React, { Component } from 'react';
import QrReader from 'react-qr-reader';

import './QrCodeReader.css';

class LecacyQrCodeReader extends Component {
  state = {
    result: 'No result',
    imageLoaded: false,
  };

  qrReader = React.createRef();

  componentDidMount() {
    setTimeout(() => {
      if (this.checkCameraPermision()) {
        console.log('have permision');
      } else {
        this.askCameraPermision();
        console.log('do not have permision');
      }
    }, 4000);
  }

  askCameraPermision = () => {
    navigator.getUserMedia(
      { video: true },
      () => {},
      (err) => console.error(err)
    );
  };

  checkCameraPermision = async () => {
    let permision = false;

    await navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        devices.forEach((device) => {
          if (device.kind === 'videoinput') {
            permision = true;
          }
        });
      })
      .catch(function(err) {
        console.log(err.name + ': ' + err.message);
      });

    return permision;
  };

  handleScan = (data) => {
    if (data) {
      this.setState({
        result: data,
      });
    }
  };

  handleError = (err) => {
    console.error(err);
  };

  openImageDialog = () => {
    this.qrReader.current.openImageDialog();
  };

  render() {
    const { result } = this.state;

    return (
      <div className="qr-reader-wrapper">
        <QrReader
          ref={this.qrReader}
          className="qr-reader"
          delay={300}
          onError={this.handleError}
          onScan={this.handleScan}
          onImageLoad={this.onImageLoad}
          legacyMode
        />
        <button onClick={this.openImageDialog}>Find QR Code</button>
        <p>{result}</p>
      </div>
    );
  }
}

export default LecacyQrCodeReader;
